(() => {
  if (window.maxlerQualityReady) return;
  window.maxlerQualityReady = true;
  const init = () => {
    const strings = JSON.parse(document.getElementById('MaxlerQualityStrings').textContent);
    const main = document.getElementById('MainContent');
    document.querySelector('a[href="#MainContent"]')?.addEventListener('click', () => main?.focus());
    const titlePreview = () => {
      const frame = document.getElementById('PBarNextFrame');
      if (!frame || window.Shopify?.theme?.role !== 'unpublished') return false;
      const source = new URL(frame.src, location.href);
      if (source.origin !== 'https://cdn.shopify.com' || source.pathname !== '/shopifycloud/preview-bar/index.html') return false;
      if (!frame.title.trim()) frame.title = strings.preview;
      return true;
    };
    if (!titlePreview()) {
      const previewObserver = new MutationObserver(() => {
        if (titlePreview()) previewObserver.disconnect();
      });
      previewObserver.observe(document.body, {childList: true, subtree: true});
      window.setTimeout(() => previewObserver.disconnect(), 30000);
    }
    document.addEventListener('reminder:openNewsletter', event => {
      const reminder = event.target;
      if (!reminder.matches?.('newsletter-reminder') || !reminder.contains(document.activeElement)) return;
      const popupId = 'NewsletterPopup-' + reminder.dataset.sectionId;
      document.addEventListener('modalClose.' + popupId, () => requestAnimationFrame(() => {
        const active = document.activeElement, popup = document.getElementById(popupId);
        if (active === document.body || reminder.contains(active) || popup?.contains(active)) main?.focus();
      }), {once: true});
    }, true);
    const slideObservers = new WeakMap();
    const galleries = root => root.querySelectorAll('.product-main-slide').forEach(slide => {
      if (slideObservers.has(slide)) return;
      const sync = () => slide.toggleAttribute('inert', slide.getAttribute('aria-hidden') === 'true');
      sync();
      const observer = new MutationObserver(sync);
      observer.observe(slide, {attributes: true, attributeFilter: ['aria-hidden']});
      slideObservers.set(slide, observer);
    });
    galleries(document);
    document.addEventListener('shopify:section:load', event => galleries(event.target));
    const focusable = container => [...container.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex]')]
      .filter(el => !el.disabled && el.tabIndex >= 0 && !el.closest('[inert]') && el.getClientRects().length && getComputedStyle(el).visibility === 'visible');
    ['NavDrawer', 'CartDrawer', 'FilterDrawer'].forEach(id => {
      document.addEventListener('drawerOpen.' + id, () => requestAnimationFrame(() => {
        const drawer = document.getElementById(id);
        if (drawer?.classList.contains('drawer--is-open')) (focusable(drawer)[0] ?? drawer).focus();
      }));
    });
    let searchTrigger, searchActive = false;
    document.querySelectorAll('.js-search-header').forEach(trigger => {
      trigger.setAttribute('aria-controls', 'MaxlerHeaderSearch');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('click', event => {
      const trigger = event.target.closest('.js-search-header');
      if (trigger) {
        searchTrigger = trigger;
        searchActive = true;
        trigger.setAttribute('aria-expanded', 'true');
      }
    }, true);
    document.addEventListener('predictive-search:close-all', () => {
      if (searchActive && searchTrigger) window.setTimeout(() => searchTrigger.focus(), 0);
      searchActive = false;
      document.querySelectorAll('.js-search-header').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    });
    document.querySelectorAll('predictive-search').forEach(search => {
      const results = search.querySelector('.search__results'), status = search.querySelector('[data-search-status]');
      if (!results || !status) return;
      new MutationObserver(() => {
        status.textContent = results.textContent.trim() ? strings.searchResults.replace('[count]', results.querySelectorAll('a[href]').length) : '';
      }).observe(results, {childList: true, subtree: true});
    });
    const localeToggle = document.getElementById('localeToggle');
    const localePanel = document.getElementById('localePanel');
    if (localeToggle && localePanel) {
      const sync = () => {
        const open = localePanel.classList.contains('active');
        if (!open && localePanel.contains(document.activeElement)) localeToggle.focus();
        localeToggle.setAttribute('aria-expanded', String(open));
        localePanel.inert = !open;
        localePanel.setAttribute('aria-hidden', String(!open));
      };
      sync();
      new MutationObserver(sync).observe(localePanel, {attributes: true, attributeFilter: ['class']});
    }
    document.querySelectorAll('.site-nav__details').forEach(details => {
      const summary = details.querySelector('summary');
      if (!summary) return;
      const sync = () => summary.setAttribute('aria-expanded', String(details.open));
      sync();
      new MutationObserver(sync).observe(details, {attributes: true, attributeFilter: ['open']});
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const details = document.activeElement.closest('.site-nav__details[open]');
        if (details) {
          details.open = false;
          window.setTimeout(() => {
            details.querySelector('summary')?.focus();
            details.open = false;
          }, 0);
          event.preventDefault();
        }
        if (localePanel?.classList.contains('active')) {
          document.getElementById('localeClose')?.click();
          window.setTimeout(() => localeToggle.focus(), 0);
          event.preventDefault();
        }
      }
      if (event.key !== 'Tab') return;
      const container = document.querySelector('.drawer.drawer--is-open') ?? document.querySelector('.site-header__search-container.is-active');
      if (!container) return;
      const controls = focusable(container), first = controls[0], last = controls.at(-1), active = document.activeElement;
      const outside = !container.contains(active) || active === container;
      if (!first) {
        event.preventDefault();
        container.focus();
      } else if (event.shiftKey && (active === first || outside)) {
        event.preventDefault();
        event.stopPropagation();
        last.focus();
      } else if (!event.shiftKey && (active === last || outside)) {
        event.preventDefault();
        event.stopPropagation();
        first.focus();
      }
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
